import React from "react";
import { Route } from "react-router-dom";
import FoodyDoc from "../views/Foodyman-doc";
import FoodyIntroduction from "../views/Foodyman-doc/Introduction";
import FoodyBasic from "../views/Foodyman-doc/Basic";
import FoodyServer from "../views/Foodyman-doc/Server";
import FoodyFront from "../views/Foodyman-doc/front";
import FoodyFrontQr from "../views/Foodyman-doc/front-qr";
import FoodyMandatorySetupWebQr from "../views/Foodyman-doc/Mandatory-setup-web-qr";
import FoodyAdmin from "../views/Foodyman-doc/admin";
import Recommendations from "../views/Foodyman-doc/recommendations";
import FoodyLocalFront from "../views/Foodyman-doc/local-front";
import FoodyMobileApp from "../views/Foodyman-doc/Mobile-app";
import FoodyFlutterSDK from "../views/Foodyman-doc/Flutter-SDK";
import FoodyLocalServer from "../views/Foodyman-doc/Local-server";
import FoodyInstallOnServer from "../views/Foodyman-doc/Install-on-server";
import FoodyMandatorySetup from "../views/Foodyman-doc/Mandatory-setup";
import FoodyCustomization from "../views/Foodyman-doc/Customization";
import FoodyMandatorySetupMobile from "../views/Foodyman-doc/Mandatory-setup-mobile";
import FoodyMandatorySetupBackend from "../views/Foodyman-doc/Mandatory-setup-backend";
import PaymentInstallation from "../views/Uzmart-doc/Payment-Installation";
import FoodyImageSettings from "../views/Foodyman-doc/image-settings";
import FoodyMandatorySetupVendor from "../views/Foodyman-doc/Moderator-setup-vendor";
import FoodyMandatorySetupCustomer from "../views/Foodyman-doc/Moderator-setup-customer";
import FoodyMandatorySetupPos from "../views/Foodyman-doc/Moderator-setup-pos";
import FoodyMandatorySetupDeliveryboy from "../views/Foodyman-doc/Moderator-setup-deliveryboy";
import FoodyCustomizationMobile from "../views/Foodyman-doc/Customization-mobile";
import CustomizationMobileDelivery from "../views/Foodyman-doc/Customization-mobile-delivery";
import CustomizationMobileCustomer from "../views/Foodyman-doc/Customization-mobile-customer";
import CustomizationMobilePos from "../views/Foodyman-doc/Customization-mobile-pos";
import AppBuildReleaseCustomer from "../views/Foodyman-doc/App-build-release-customer";
import AppBuildReleasePos from "../views/Foodyman-doc/App-build-release-pos";
import AppBuildReleaseVendor from "../views/Foodyman-doc/App-build-release-vendor";
import AppBuildReleaseDelivery from "../views/Foodyman-doc/App-build-release-deliveryboy";
import FoodyMandatorySetupWeb from "../views/Foodyman-doc/Mandatory-setup-web";
import FoodyBuildCodeAndSetupOnServer from "../views/Foodyman-doc/Build-code-and-setup-on-server";
import FoodyBuildCodeAndSetupOnServerBackend from "../views/Foodyman-doc/Build-code-and-setup-on-server-backend";
import FoodyUpdateAdminPanel from "../views/Foodyman-doc/Update-admin-panel";
import FoodyUpdateAppWeb from "../views/Foodyman-doc/Update-app-web";
import FoodySupportPlan from "../views/Foodyman-doc/supportPlan";
import FoodyFirebaseSetup from "../views/Sundaymart_v2-doc/firebase-setup";
import TroubleshootingBackend from "../views/Foodyman-doc/Troubleshooting-backend";
import TroubleshootingAdmin from "../views/Foodyman-doc/Troubleshooting-admin";
import UpdateFooyman from "../views/Foodyman-doc/update";
import MandatorySetupKiosk from "../views/Foodyman-doc/Moderator-setup-kiosk";
import CustomizationMobileKiosk from "../views/Foodyman-doc/Customization-mobile-kiosk";
import AppBuildReleaseSingleKiosk from "../views/Foodyman-doc/App-build-release-kiosk";
import FoodyQRApp from "../views/Foodyman-doc/qr-code";
import FoodyInstallQRcode from "../views/Foodyman-doc/install-qrcode";

const Foodyman = () => {
  return (
    <Route path="/foodyman-documentation" element={<FoodyDoc />}>
      <Route
        path="/foodyman-documentation/introduction"
        element={<FoodyIntroduction />}
      />
      <Route path="/foodyman-documentation/basic" element={<FoodyBasic />} />
      <Route path="/foodyman-documentation/server" element={<FoodyServer />} />
      <Route path="/foodyman-documentation/front" element={<FoodyFront />} />
      <Route
        path="/foodyman-documentation/front-qr"
        element={<FoodyFrontQr />}
      />
      <Route
        path="/foodyman-documentation/mandatory-setup-web-qr"
        element={<FoodyMandatorySetupWebQr />}
      />
      <Route path="/foodyman-documentation/admin" element={<FoodyAdmin />} />
      <Route
        path="/foodyman-documentation/recommendations"
        element={<Recommendations />}
      />
      <Route
        path="/foodyman-documentation/local-front"
        element={<FoodyLocalFront />}
      />
      <Route
        path="/foodyman-documentation/mobile-app"
        element={<FoodyMobileApp pageTitle="Customer App" />}
      />
      <Route
        path="/foodyman-documentation/vendor-app"
        element={<FoodyMobileApp pageTitle="Vendor App" />}
      />
      <Route
        path="/foodyman-documentation/driver-app"
        element={<FoodyMobileApp pageTitle="Driver App" />}
      />
      <Route
        path="/foodyman-documentation/pos-app"
        element={<FoodyMobileApp pageTitle="Pos App" />}
      />
      <Route
        path="/foodyman-documentation/flutter-sdk"
        element={<FoodyFlutterSDK />}
      />
      <Route
        path="/foodyman-documentation/local-server"
        element={<FoodyLocalServer />}
      />
      <Route
        path="/foodyman-documentation/install-on-server"
        element={<FoodyInstallOnServer />}
      />
      <Route
        path="/foodyman-documentation/mandatory-setup"
        element={<FoodyMandatorySetup />}
      />
      <Route
        path="/foodyman-documentation/customization"
        element={<FoodyCustomization />}
      />
      <Route
        path="/foodyman-documentation/mandatory-setup-mobile"
        element={<FoodyMandatorySetupMobile />}
      />
      <Route
        path="/foodyman-documentation/mandatory-setup-backend"
        element={<FoodyMandatorySetupBackend />}
      />
      <Route
        path="/foodyman-documentation/payment-installation"
        element={<PaymentInstallation />}
      />
      <Route
        path="/foodyman-documentation/image-settings"
        element={<FoodyImageSettings />}
      />
      <Route
        path="/foodyman-documentation/mandatory-setup-vendor"
        element={<FoodyMandatorySetupVendor />}
      />
      <Route
        path="/foodyman-documentation/mandatory-setup-customer"
        element={<FoodyMandatorySetupCustomer />}
      />
      <Route
        path="/foodyman-documentation/mandatory-setup-pos"
        element={<FoodyMandatorySetupPos />}
      />
      <Route
        path="/foodyman-documentation/mandatory-setup-deliveryboy"
        element={<FoodyMandatorySetupDeliveryboy />}
      />
      <Route
        path="/foodyman-documentation/customization-vendor"
        element={<FoodyCustomizationMobile />}
      />
      <Route
        path="/foodyman-documentation/customization-deliveryboy"
        element={<CustomizationMobileDelivery />}
      />
      <Route
        path="/foodyman-documentation/customization-customer"
        element={<CustomizationMobileCustomer />}
      />
      <Route
        path="/foodyman-documentation/customization-pos"
        element={<CustomizationMobilePos />}
      />
      <Route
        path="/foodyman-documentation/customer-app-build-release"
        element={<AppBuildReleaseCustomer />}
      />
      <Route
        path="/foodyman-documentation/pos-app-build-release"
        element={<AppBuildReleasePos />}
      />
      <Route
        path="/foodyman-documentation/vendor-app-build-release"
        element={<AppBuildReleaseVendor />}
      />
      <Route
        path="/foodyman-documentation/deliveryboy-app-build-release"
        element={<AppBuildReleaseDelivery />}
      />
      <Route
        path="/foodyman-documentation/mandatory-setup-web"
        element={<FoodyMandatorySetupWeb />}
      />
      <Route
        path="/foodyman-documentation/build-code-and-setup-on-server"
        element={<FoodyBuildCodeAndSetupOnServer />}
      />
      <Route
        path="/foodyman-documentation/build-code-and-setup-on-server-backend"
        element={<FoodyBuildCodeAndSetupOnServerBackend />}
      />
      <Route
        path="/foodyman-documentation/update-admin-panel"
        element={<FoodyUpdateAdminPanel />}
      />
      <Route
        path="/foodyman-documentation/update-app-web"
        element={<FoodyUpdateAppWeb />}
      />
      <Route
        path="/foodyman-documentation/support-plan"
        element={<FoodySupportPlan />}
      />
      <Route
        path="/foodyman-documentation/firebase"
        element={<FoodyFirebaseSetup />}
      />
      <Route
        path="/foodyman-documentation/google-services"
        element={<FoodyFirebaseSetup projectTitle="Foodyman" />}
      />

      <Route
        path="/foodyman-documentation/troubleshooting-backend"
        element={<TroubleshootingBackend />}
      />
      <Route
        path="/foodyman-documentation/troubleshooting-admin"
        element={<TroubleshootingAdmin />}
      />
      <Route
        path="/foodyman-documentation/update"
        element={<UpdateFooyman />}
      />
      <Route
        path="/foodyman-documentation/kiosk-app"
        element={<FoodyMobileApp pageTitle="Kiosk App" />}
      />
      <Route
        path="/foodyman-documentation/mandatory-setup-kiosk"
        element={<MandatorySetupKiosk />}
      />
      <Route
        path="/foodyman-documentation/customization-kiosk"
        element={<CustomizationMobileKiosk />}
      />
      <Route
        path="/foodyman-documentation/kiosk-app-build-release"
        element={<AppBuildReleaseSingleKiosk />}
      />
      <Route path="/foodyman-documentation/qr-app" element={<FoodyQRApp />} />
      <Route
        path="/foodyman-documentation/install-qrcode"
        element={<FoodyInstallQRcode />}
      />
    </Route>
  );
};

export default Foodyman;
